export enum TypeNotificationsEnum {
  AGENDAMENTO = 'agendamento',
  FINANCEIRO = 'financeiro',
  GENERICO = 'generico',
}


export enum TypeContentNotificationsEnum {
  VIDEO = 'VIDEO',
  BANNER = 'BANNER',
  TEXTO = 'TEXTO'
}